import { BannerSection } from 'components/BannerSection'
import { Button } from '@sketch/components'
import { useModalContext } from 'containers/ModalManager'
import { PublishProfileModal } from 'modules/workspaceProfile/modals'
import React from 'react'

export interface WorkspaceSettingsProfileProps {
  identifier: string
}

export const PublishProfileSection = (props: WorkspaceSettingsProfileProps) => {
  const { showModal } = useModalContext()
  const { identifier } = props

  return (
    <BannerSection
      type="neutral"
      button={
        <Button
          size="40"
          variant="primary-untinted"
          onClick={() => showModal(PublishProfileModal, { identifier })}
        >
          Publish Profile…
        </Button>
      }
    >
      Your public profile is hidden — only you and other Admins can see it.
    </BannerSection>
  )
}
